import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },

    {
      path: '/abouts',
      name: 'abouts',
      component: () => import('./views/abouts.vue'),
    },

    {
      path: '/product',
      name: 'product',
      component: () => import('./views/Product.vue'),
    },
    {
      path: '/case',
      name: 'case',
      component: () => import('./views/Case.vue'),
    },
    {
      path: '/technology',
      name: 'technology',
      component: () => import('./views/technology.vue'),
    },
    {
      path: '/casedetails/:id',
      name: 'casedetails',
      component: () => import('./views/CaseDetails.vue'),
    },
  ],
});

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  next();
});

export default router;
